import { css } from '@emotion/css';

export const selectFormEditorOptionsItemStyles = css`
  &:hover,
  &.Mui-focused {
    .opacity-0 {
      opacity: 1;
    }
  }
`;
